'use client';
import React, { useState } from 'react';
import styles from './switch.module.sass';
import cn from 'classnames';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    reverse?: boolean;
}

export const Switch = ({ label, reverse, disabled, className, ...props }: SwitchProps) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
        if (props.onChange) {
            props.onChange(event); // propagate to parent if needed
        }
    };

    const classes = cn(styles.switch, className);

    return (
        <label className={classes}>
            <input type="checkbox" checked={isChecked} disabled={!!disabled} onChange={handleToggle} {...props} />
            {!reverse && <b></b>}
            {label && <span className={styles.label}>{label}</span>}
            {reverse && <b></b>}
        </label>
    );
};
